import { useEffect, useRef, useState } from "react";
import { WS_URL } from "../lib/api";

// Live feed via WebSocket with graceful fallback flag.
export function useLiveFeed({ maxBlocks = 12, maxTxs = 14 } = {}) {
  const [blocks, setBlocks] = useState([]);
  const [txs, setTxs] = useState([]);
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);
  const retry = useRef(null);

  useEffect(() => {
    let closed = false;
    const connect = () => {
      try {
        const ws = new WebSocket(WS_URL);
        wsRef.current = ws;
        ws.onopen = () => setConnected(true);
        ws.onclose = () => {
          setConnected(false);
          if (!closed) retry.current = setTimeout(connect, 3000);
        };
        ws.onerror = () => ws.close();
        ws.onmessage = (e) => {
          try {
            const msg = JSON.parse(e.data);
            if (msg.type === "block") {
              setBlocks((prev) => {
                if (prev.some((b) => b.number === msg.block.number)) return prev;
                return [{ ...msg.block, _new: true }, ...prev].slice(0, maxBlocks);
              });
            } else if (msg.type === "tx") {
              setTxs((prev) => {
                if (prev.some((t) => t.hash === msg.tx.hash)) return prev;
                return [{ ...msg.tx, _new: true }, ...prev].slice(0, maxTxs);
              });
            }
          } catch {}
        };
      } catch {
        if (!closed) retry.current = setTimeout(connect, 3000);
      }
    };
    connect();
    return () => {
      closed = true;
      clearTimeout(retry.current);
      try { wsRef.current?.close(); } catch {}
    };
  }, [maxBlocks, maxTxs]);

  return { blocks, txs, connected, setBlocks, setTxs };
}
